import { isEmpty, type Optional } from '@festina-life/core'

import { useCompareContext } from './valueSetupCompareContext'

export const useHideInheritanceDiff = (currentValue: Optional<unknown>) => {
  const { compareType } = useCompareContext()
  const isEmptyValue = Array.isArray(currentValue)
    ? !currentValue.length
    : isEmpty(currentValue)

  return compareType === 'inherited' && isEmptyValue
}
